import {
  getDictInfoByCode
} from '@/api/dict'
export default {
  state: {
    assessResultList: [],
    assessDept: {}
  },
  getters: {
    assessResultList: (state) => state.assessResultList,
    assessDept: state => state.assessDept
  },
  mutations: {
    assessResultList(state, data) {
      state.assessResultList = data
    },
    assessDept(state, data) {
      state.assessDept = data
    }
  },
  actions: {
    handleAssessDept(assessDept, data) {
      assessDept.commit('assessDept', data)
    },
    handleAssessResultList(assessResultList) {
      getDictInfoByCode({
        pCode: 'ASSESS_RESULT'
      }).then(res => {
        if (res.status === 0) {
          assessResultList.commit('assessResultList', res.data)
        }
      })
    }
  }
}